class KeyAnnouncement {
  constructor() {
    this.initKeyAnnouncement();
  }

  initKeyAnnouncement() {
    const closeBtns = document.querySelectorAll('[data-key-announcement-close-btn]');
    closeBtns.forEach((item) => {
      item.addEventListener('click', this.hideBanner);
    });
  }

  hideBanner(event) {
    const banner = event.target.closest('[data-key-announcement]');

    if (banner) {
      banner.classList.add('hidden');
    }
  }
}

export default KeyAnnouncement;
